"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var react_intl_1 = require("react-intl");
var usePopover_1 = require("../hooks/usePopover");
var locales_1 = __importDefault(require("../resources/locales"));
var constants_1 = require("../constants");
var NotificationPanel_1 = __importDefault(require("./notification-panel/NotificationPanel"));
var BellIcon_1 = __importDefault(require("../resources/icons/BellIcon"));
var defineTheme = function (outerTheme) {
    var _a;
    var theme = __assign({}, outerTheme);
    if ((_a = outerTheme.variables) === null || _a === void 0 ? void 0 : _a.palette.notificationsPanel) {
        return core_1.createMuiTheme(outerTheme);
    }
    theme.variables.palette.notificationsPanel = constants_1.defaultTheme;
    return core_1.createMuiTheme(theme);
};
var NotificationWidget = function (props) {
    var _a = usePopover_1.usePopover(), anchorEl = _a.anchorEl, setPopoverClose = _a.setPopoverClose, setPopoverOpen = _a.setPopoverOpen, isOpen = _a.isOpen;
    var _b = props.locale, locale = _b === void 0 ? constants_1.defaultLocale : _b, loadCountNotViewedMessages = props.loadCountNotViewedMessages;
    var _c = react_1.useState(0), notViewedNotifications = _c[0], setNotViewedNotifications = _c[1];
    react_1.useEffect(function () {
        loadCountNotViewedMessages().then(setNotViewedNotifications);
    }, [loadCountNotViewedMessages, setNotViewedNotifications]);
    return (react_1.default.createElement(core_1.ThemeProvider, { theme: defineTheme },
        react_1.default.createElement(react_intl_1.IntlProvider, { locale: locale, messages: locales_1.default[locale] },
            react_1.default.createElement(core_1.IconButton, { color: "secondary", onClick: setPopoverOpen, id: "bell-icon" },
                react_1.default.createElement(core_1.Badge, __assign({}, (notViewedNotifications && { badgeContent: notViewedNotifications }), { color: "error" }),
                    react_1.default.createElement(BellIcon_1.default, null))),
            react_1.default.createElement(NotificationPanel_1.default, __assign({ isOpen: isOpen, anchorEl: anchorEl, setPopoverClose: setPopoverClose, setNotViewedNotifications: setNotViewedNotifications, notViewedNotifications: notViewedNotifications }, props)))));
};
exports.default = NotificationWidget;
